module.exports = __webpack_public_path__ + "img/group.0c474561.svg";